'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toHomeList = require('./to-home-list');

var _toHomeList2 = _interopRequireDefault(_toHomeList);

var _toForeignList = require('./to-foreign-list');

var _toForeignList2 = _interopRequireDefault(_toForeignList);

var _position = require('../../position');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var pageCenter = _ref.pageCenter,
      destination = _ref.destination,
      draggable = _ref.draggable,
      target = _ref.target,
      home = _ref.home,
      insideDestination = _ref.insideDestination;

  var amount = (0, _position.patch)(destination.axis.line, draggable.page.withMargin[destination.axis.size]);

  if (destination.id === draggable.droppableId) {
    return (0, _toHomeList2.default)({
      amount: amount,
      originalIndex: home.index,
      target: target,
      insideDroppable: insideDestination,
      draggable: draggable,
      droppable: destination
    });
  }

  return (0, _toForeignList2.default)({
    amount: amount,
    pageCenter: pageCenter,
    target: target,
    insideDroppable: insideDestination,
    draggable: draggable,
    droppable: destination
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/state/move-cross-axis/move-to-new-droppable/index.js
// module id = 2989
// module chunks = 0